import {
  nullableStreamId,
  RoomId,
  roomId,
  RoomStageLayout,
  roomStageLayout,
  StreamId,
  streamIds
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutStreamsSetEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutStreamsSetEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutStreamsSetEventDTORaw) {
    JsonSchemaValidator.assert(
      RoomStageLayoutStreamsSetEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "layout", "videos", "audios"],
      properties: {
        roomId,
        layout: roomStageLayout,
        videos: streamIds,
        audios: streamIds,
        focus: nullableStreamId,
        main: nullableStreamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStageLayoutStreamsSetEventDTORaw {
  roomId: RoomId;
  layout: RoomStageLayout;
  videos: StreamId[];
  audios: StreamId[];
  focus?: null | StreamId;
  main?: null | StreamId;
}
